<template>
  <!--FBA头程 订单列表-->
  <div class="page-box" v-loading="loading">
    <h4 class="page-box__title">我的订单</h4>
    <el-form
      class=""
      :model="searchData"
      ref="searchForm"
      label-width="130px"
      :inline="true"
      @submit.native.prevent
    >
      <el-form-item label="运单号">
        <el-input
          v-model="searchData.innos"
          size="mini"
          class="edit-form__input"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="主单号">
        <el-input
          v-model="searchData.orderNo"
          size="mini"
          class="edit-form__input"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="目的国家">
        <el-select
          v-model="searchData.recgoodscountry"
          @change="changeCountryId"
          size="mini"
          class="edit-form__input"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in countryList"
            :key="index"
            :label="item.namec"
            :value="item.namec"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目的仓库">
        <el-select
          v-model="searchData.towarehouseid"
          size="mini"
          :disabled="warehouseList.length <= 0"
          class="edit-form__input"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in warehouseList"
            :key="index"
            :label="item.namec"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="询盘业务类型">
        <el-select
          v-model="searchData.inquiryBusinessType"
          size="mini"
          clearable
          class="edit-form__input"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in inquiryBusinessTypes"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单类别">
        <el-select
          v-model="searchData.inquiryOrderType"
          size="mini"
          clearable
          class="edit-form__input"
          placeholder="请选择"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="查价订单" :value="1"></el-option>
          <el-option label="询盘订单" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单日期">
        <el-date-picker
          v-model="startDateValue"
          @change="changeStartDateValue"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder=""
          end-placeholder=""
          clearable
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="订单推送状态">
        <el-select
          v-model="searchData.sendStatus"
          size="mini"
          class="edit-form__input"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in sendStatusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否会员相互配单">
        <el-select
          v-model="searchData.whetherOrder"
          size="mini"
          class="edit-form__input"
          placeholder="请选择"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" " label-width="10px">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div class="" style="margin: 15px auto">
      <el-button type="" icon="el-icon-plus" @click="showEditForm"
        >导入轨迹</el-button
      >
    </div>
    <el-table
      :data="tableData"
      @selection-change="selectionChangeValue"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      size="mini"
      highlight-current-row
      style="width: 100%"
      border
    >
      <el-table-column label="" type="selection" width="40"></el-table-column>
      <el-table-column
        label="运单号"
        align="center"
        min-width="130"
        prop="innos"
      ></el-table-column>
      <el-table-column label="状态" align="center" min-width="130" prop="state">
        <template slot-scope="scope">
          {{
            !scope.row.state
              ? ""
              : orderTypesMapObject[scope.row.state] || scope.row.state
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="平台订单状态"
        align="center"
        min-width="130"
        prop="orderPlatformTrackStateName"
      >
      </el-table-column>

      <el-table-column
        label="运力商产品名"
        align="center"
        min-width="130"
        prop="lineProductName"
      >
        <template v-slot="scope">
          {{ scope.row.lineProductName || "/" }}
        </template>
      </el-table-column>
      <el-table-column
        label="货代拼产品名"
        align="center"
        min-width="130"
        prop="logisticsProductName"
      >
        <template v-slot="scope">
          {{ scope.row.logisticsProductName || "/" }}
        </template>
      </el-table-column>
      <el-table-column
        label="运输方案名称"
        align="center"
        min-width="130"
        prop="transportScheme"
      >
        <template v-slot="scope">
          {{ scope.row.transportScheme || "/" }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单类别"
        align="center"
        min-width="130"
        prop="orderType"
      ></el-table-column>
      <el-table-column
        label="运输方式"
        align="center"
        min-width="130"
        prop="transportType"
      >
        <template slot-scope="scope">
          {{
            allTransportTypesMapObject[scope.row.transportType] ||
            scope.row.transportType ||
            "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="询盘业务类型"
        align="center"
        min-width="130"
        prop="inquiryBusinessType"
      >
        <template v-slot="scope">
          {{ scope.row.inquiryBusinessType || "/" }}
        </template>
      </el-table-column>
      <el-table-column
        label="FBA仓"
        align="center"
        min-width="130"
        prop="fbawarehouse"
      >
        <template slot-scope="scope">
          {{ scope.row.fbawarehouse || scope.row.recwarehousecode || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        label="货物类型"
        align="center"
        min-width="130"
        prop="goodstype"
      ></el-table-column>
      <el-table-column
        label="预报总重量(KG)"
        align="center"
        min-width="130"
        prop="preboxweight"
      ></el-table-column>
      <el-table-column
        label="预报总体积(CBM)"
        align="center"
        min-width="130"
        prop="preboxcbm"
      ></el-table-column>
      <el-table-column
        label="预报总箱数"
        align="center"
        min-width="130"
        prop="preboxcount"
      ></el-table-column>
      <el-table-column
        label="主单号"
        align="center"
        min-width="130"
        prop="orderNo"
      ></el-table-column>
      <!--      <el-table-column label="实际总重量(KG)"-->
      <!--                       align="center"-->
      <!--                       min-width="130"-->
      <!--                       prop="boxweight"></el-table-column>-->
      <!--      <el-table-column label="实际总体积(CBM)"-->
      <!--                       align="center"-->
      <!--                       min-width="130"-->
      <!--                       prop="boxcbm"></el-table-column>-->
      <!--      <el-table-column label="实际总箱数"-->
      <!--                       align="center"-->
      <!--                       min-width="130"-->
      <!--                       prop="boxcount"></el-table-column>-->
      <el-table-column
        label="专线入仓信息"
        align="center"
        min-width="130"
        prop="isconfirmtime"
      >
        <template v-slot="scope">
          <div>重量:{{ scope.row.boxweight }}kg</div>
          <div>体积:{{ scope.row.boxcbm }}cbm</div>
          <div>箱数:{{ scope.row.boxcount }}箱</div>
          <!--          <div>计费重:-</div>-->
          <!--          <div>费用:-</div>-->
        </template>
      </el-table-column>
      <el-table-column
        label="入仓时间"
        align="center"
        min-width="130"
        prop="isconfirmtime"
      ></el-table-column>
      <el-table-column
        label="入仓确认人"
        align="center"
        min-width="130"
        prop="isconfirmer"
      ></el-table-column>
      <el-table-column label="订单推送状态" align="center" min-width="130">
        <template slot-scope="scope">
          <template v-if="scope.row.sendStatus === null"> 未推送 </template>
          <template v-else>
            {{
              sendStatusListMapObject[scope.row.sendStatus] ||
              scope.row.sendStatus ||
              "-"
            }}
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="跟踪单号"
        align="center"
        min-width="130"
        prop="trackingNumber"
      />
      <el-table-column
        label="是否会员相互配单"
        align="center"
        min-width="140"
        prop="whetherOrder"
      />
      <el-table-column
        label="客户名称"
        align="center"
        min-width="130"
        prop="customerName"
      >
        <template slot-scope="scope">
          {{ scope.row.whetherOrder === "是" ? scope.row.customerName : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="160"
        fixed="right"
        header-align="center"
        align="left"
      >
        <template slot-scope="scope">
          <div
            class="table-button-plain open-hover"
            @click="viewDetails(scope.row)"
          >
            查看详情
          </div>
          <template v-if="['A', 'O'].includes(scope.row.state)">
            <div
              class="table-button-plain color-primary open-hover"
              @click="showAddService(scope.row)"
            >
              添加服务
            </div>
            <div
              class="table-button-plain color-success open-hover"
              @click="showTrackList(scope.row)"
            >
              轨迹管理
            </div>
          </template>
          <el-link
            type="warning"
            :underline="false"
            @click="clickEditClientNos(scope.row)"
            v-if="[0, null, 2].includes(scope.row.sendStatus)"
            >跟踪单号编辑</el-link
          >
          <el-link
            type="primary"
            :underline="false"
            @click="handleInWarehouse(scope.row)"
            v-if="scope.row.state === 'I'"
            >入仓</el-link
          >
          <el-link
            type="primary"
            :underline="false"
            @click="handleOutWarehouse(scope.row)"
            v-if="scope.row.state === 'A'"
            >出仓</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="paging-row"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalListNum"
    >
    </el-pagination>
    <el-dialog
      title=""
      width="760px"
      custom-class="edit-dialog"
      :visible.sync="visibleEditForm"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo margin-bottom"
        style="text-align: center"
        :show-file-list="false"
        :headers="uploadHeader"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :action="upUrl"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅限xls和xlsx文件</div>
      </el-upload>
      <el-table
        :data="tableDataUpload"
        v-show="tableDataUpload.length > 0"
        size="mini"
        align="center"
        border
        max-height="400px"
        style="width: 100%"
      >
        <el-table-column label="序号" width="50" type="index"></el-table-column>
        <el-table-column
          label="单号"
          min-width="150"
          prop="comId"
        ></el-table-column>
        <el-table-column label="状态" width="100" prop="failureReason">
          <template slot-scope="scope">
            <span
              :class="[scope.row.isSuccess ? 'color-success' : 'color-danger']"
              >{{ scope.row.isSuccess ? "成功" : "失败" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="错误描述" min-width="200" prop="">
          <template slot-scope="scope">
            <span
              :class="[scope.row.isSuccess ? 'color-success' : 'color-danger']"
              >{{ scope.row.failureReason }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center">
        <el-button @click="hideEditForm" style="margin-right: 20px" size="mini"
          >取 消</el-button
        >
        <el-link
          :href="downUrl"
          :disabled="!downUrl"
          type="success"
          target="_blank"
        >
          <el-button size="mini" type="success">下载模板</el-button>
        </el-link>
      </div>
    </el-dialog>
    <el-dialog
      title="添加服务"
      width="400px"
      custom-class="edit-dialog"
      :visible.sync="visibleAddService"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        class=""
        :model="editAddService"
        ref="addService"
        label-width="100px"
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item label="服务名称" prop="name" :rules="formRules.require">
          <el-select
            v-model="editAddService.name"
            class="edit-form__input"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in feeList"
              :key="index"
              :label="item.namec"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="num" :rules="formRules.require">
          <el-input
            v-model="editAddService.num"
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price" :rules="formRules.require">
          <el-input
            v-model="editAddService.price"
            disabled
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="sum" :rules="formRules.require">
          <el-input
            v-model="editAddService.sum"
            disabled
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="" @click="hideAddService">取消 </el-button>
          <el-button
            type="primary"
            @click="clickSaveAddService()"
            style="margin-left: 30px"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="轨迹管理"
      width="900px"
      custom-class="edit-dialog"
      :visible.sync="visibleTrackList"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="margin-bottom">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="showAddTrack()"
          >新增</el-button
        >
        <!--<el-button type="danger"-->
        <!--icon="el-icon-delete"-->
        <!--:disabled="tableDataSelectValueTrack.length <= 0"-->
        <!--size="mini"-->
        <!--&gt;删除</el-button>-->
      </div>
      <el-table
        :data="tableDataTrack"
        max-height="400"
        @selection-change="selectionChangeValueTrack"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        size="mini"
        highlight-current-row
        style="width: 100%"
        border
      >
        <!--<el-table-column label=""-->
        <!--type="selection"-->
        <!--width="40"></el-table-column>-->
        <el-table-column
          label="轨迹发生时间"
          align="center"
          min-width="130"
          prop="dealdata"
        ></el-table-column>
        <el-table-column
          label="地点"
          align="center"
          min-width="130"
          prop="locationc"
        ></el-table-column>
        <el-table-column
          label="地点(英)"
          align="center"
          min-width="130"
          prop="locatione"
        ></el-table-column>
        <el-table-column
          label="状态"
          align="center"
          min-width="130"
          prop="statusc"
        ></el-table-column>
        <el-table-column
          label="状态(英)"
          align="center"
          min-width="130"
          prop="statuse"
        ></el-table-column>
        <el-table-column
          label="备注"
          align="center"
          min-width="130"
          prop="remarks"
        ></el-table-column>
        <el-table-column
          label="录入人"
          align="center"
          min-width="130"
          prop="inputer"
        ></el-table-column>
        <el-table-column
          label="录入时间"
          align="center"
          min-width="130"
          prop="inputtime"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="100"
          fixed="right"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="clickDeleteTrack(scope.row)"
              size="mini"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="新增轨迹"
      width="420px"
      custom-class="edit-dialog"
      :visible.sync="visibleAddTrack"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        class=""
        :model="editAddTrack"
        ref="addTrack"
        label-width="100px"
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item label="状态" prop="tempId" :rules="formRules.require">
          <el-select
            v-model="editAddTrack.tempId"
            @change="changeTrackStatusId"
            class="edit-form__input"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in trackStatusList"
              :key="index"
              :label="item.statusc"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" prop="dealdata" :rules="formRules.require">
          <el-date-picker
            v-model="editAddTrack.dealdata"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地点" prop="locationc">
          <el-input
            v-model="editAddTrack.locationc"
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="地点(英)" prop="locatione">
          <el-input
            v-model="editAddTrack.locatione"
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态(英)" prop="statuse">
          <el-input
            :value="editAddTrack.statuse"
            disabled
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="editAddTrack.remarks"
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="" @click="hideAddTrack">取消 </el-button>
          <el-button
            type="primary"
            @click="clickSaveAddTrack()"
            style="margin-left: 30px"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <edit-client-nos
      :visible.sync="visibleEditClientNos"
      :before-order-id="editClientNosData.beforeOrderId"
      :nos="editClientNosData.trackingNumber"
      @success="getList"
      @closed="hideEditClientNos"
    />
  </div>
</template>

<script>
import { disposeSearchData, mapFromArrayToObject } from "@/assets/js/utils";
import { pagingMixins } from "@/assets/js/pagingMixins";
import { rulesNotEmpty } from "@/assets/js/formRules";
import EditClientNos from "@/components/orderManagement/components/editClientNos";
import { sendCustomerOperationRecord } from "../../assets/js/baseDataRuquest";

let allTransportTypes = [
  { label: "全部", value: "" },
  { label: "陆运", value: "LY" },
  { label: "海运", value: "HY" },
  { label: "空运", value: "KY" },
];
let orderTypes = [
  { label: "全部", value: "" },
  { label: "未入仓", value: "I" },
  { label: "已入仓", value: "A" },
  { label: "已出仓", value: "O" },
];
let sendStatusList = [
  { label: "全部", value: "" },
  { label: "未推送", value: "0" },
  { label: "推送成功", value: "1" },
  { label: "推送失败", value: "2" },
  // {label:"作废",value:"3",},
  { label: "无需推送", value: "3" },
];
export default {
  name: "FBAHeader",
  components: { EditClientNos },
  mixins: [pagingMixins],
  data() {
    return {
      /* 筛选 */
      searchData: {
        innos: "", //运单号
        orderNo: "", //主单号
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        recgoodscountry: "", // 目的国家
        towarehouseid: "", // 目的仓id
        sendStatus: "", // 订单推送状态 0 未推送 1 推送成功 2 推送失败
        whetherOrder: "",
        inquiryBusinessType: "",
        inquiryOrderType: "",
      },
      inquiryBusinessTypes: [
        { label: "全部", value: "" },
        { label: "海运整柜", value: 1 },
        { label: "FBA", value: 2 },
        { label: "海运拼箱", value: 3 },
        { label: "国际空运", value: 4 },
        { label: "陆运", value: 5 },
      ],
      inquiryBusinessTypesMap: {
        1: "海运整柜",
        2: "FBA",
        3: "海运拼箱",
        4: "国际空运",
        5: "陆运",
      },
      /* 选择框 数据 */
      startDateValue: [], //
      countryList: [], // 目的国家
      warehouseList: [], //目的仓
      allTransportTypesMapObject: mapFromArrayToObject(allTransportTypes), //运输方式
      orderTypesMapObject: mapFromArrayToObject(orderTypes), //订单状态
      //订单推送状态
      sendStatusList: sendStatusList,
      sendStatusListMapObject: mapFromArrayToObject(sendStatusList),
      /* 编辑弹窗 */
      visibleEditForm: false,
      editFormData: {},
      /* 添加服务 */
      visibleAddService: false,
      feeList: [],
      editAddService: {
        id: "",
        name: "",
        num: "",
        price: "",
        sum: "",
      },
      /* 轨迹管理 */
      visibleTrackList: false,
      //轨迹管理需要的前置参数
      editTrackNeedParams: {},
      // 当前订单轨迹记录数据
      tableDataTrack: [],
      // 当前订单轨迹记录数据选中的项
      tableDataSelectValueTrack: [],
      // 轨迹状态列表
      trackStatusList: [],
      /* 新增轨迹 */
      formRules: {
        no: [{ trigger: "blur", required: false }],
        require: [rulesNotEmpty()],
        location: [
          rulesNotEmpty(),
          { trigger: "blur", pattern: /^.{4,30}$/, message: "6-30个字符" },
        ],
      },
      visibleAddTrack: false,
      editAddTrack: {
        dealdata: "", //轨迹发生时间
        // id:"",
        // inputer:"",//轨迹录入人
        // inputtime:"",//轨迹录入时间
        jobId: "", //jobId
        nos: "",
        locationc: "", //轨迹地点中文名
        locatione: "", //轨迹地点英文名
        statusc: "", //轨迹状态中文名
        statuse: "", //轨迹状态英文名
        tempId: "", //轨迹模板Id
        code: "", //轨迹模板code
        remarks: "", //备注
      },
      /* 上传、下载模板 */
      uploadHeader: { token: "" },
      upUrl: "", // 上传模板地址
      downUrl: "", // 下载模板地址
      tableDataUpload: [],

      /* 编辑客户单号 */
      visibleEditClientNos: false,
      editClientNosData: {
        beforeOrderId: "",
        nos: "",
      },
    };
  },
  created() {
    this.uploadHeader.token = this.$store.state.Authorization.token;
    this.upUrl = "/api" + "/carrier/order/importJobsTrackByNosOrBoxNo";
    this.downUrl = "/api" + "/carrier/order/downJobsTrackTemp";
    this.getCountryList();
    this.getList();
  },
  methods: {
    /**
     * 获取 目的国家/仓库
     */
    getCountryList() {
      return new Promise((resolve, reject) => {
        this.axios
          .get("/warehouse/getFBAWarehouseList", {})
          .then((res) => {
            if (res.data.code !== 200) {
              return false;
            }
            res.data.datas.forEach((res) => {
              if (res.children) res.children.unshift({ namec: "全部", id: "" });
            });
            res.data.datas.unshift({ namec: "全部", id: "" });
            this.countryList = res.data.datas;
            resolve(res);
          })
          .catch((res) => {});
      });
    },
    changeCountryId(value) {
      this.searchData.towarehouseid = "";
      let list = [];
      if (value) {
        if (value === "全部") {
          this.searchData.recgoodscountry = "";
        } else {
          let target = this.countryList.find((res) => res.namec === value);
          if (target) {
            list = target.children || [];
          }
        }
      }
      this.warehouseList = list;
    },
    /**
     * 获取 列表
     */
    getList() {
      let data = this.jointSearchData();
      console.log("ddd", data);
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.axios
          .post("/carrier/order/getFirstLegOrderPageList", data)
          .then((res) => {
            console.log("res.data ", res);
            this.loading = false;
            if (res.data.code !== 200) {
              this.tableData = [];
              this.totalListNum = 10;
              this.$message.info(res.data.message || "获取列表：服务器繁忙");
              return false;
            }
            this.tableData = res.data.data.list;
            this.totalListNum = res.data.data.total;
            resolve(res);
          })
          .catch((res) => {
            this.loading = false;
            this.tableData = [];
            this.totalListNum = 10;
          });
      });
    },
    /**
     *  其他
     */
    /*查询时间*/
    changeStartDateValue(value) {
      if (!value) value = [];
      this.searchData.startTime = value[0];
      this.searchData.endTime = value[1];
    },
    /*上传*/
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限xls和xlsx");
        return false;
      }
    },
    handleError(err) {
      // debugger
      this.$message.info(err.data);
    },
    handleSuccess(res) {
      if (typeof res === "string") {
        this.$message.info(res);
        return false;
      }
      //  console.log(response);
      if (res.code !== 200) {
        this.$message.info(res.error);
        return false;
      }
      this.$message.success("上传成功");
      this.tableDataUpload = res.datas;
      sendCustomerOperationRecord("导入轨迹");
    },
    /*查看详情*/
    viewDetails(row) {
      this.$router.push({
        name: "FBAHeaderDetails",
        query: { id: row.id, state: row.state },
      });
    },
    /**
     * 添加服务
     * */
    showAddService(row) {
      // this.editAddService.id = row.id;
      this.visibleAddService = true;
    },
    hideAddService() {
      this.visibleAddService = false;
    },
    clickSaveAddService(formName = "addService") {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$message.success("调用添加服务接口");
      });
    },
    /**
     * 轨迹管理
     */
    showTrackList(row) {
      this.editTrackNeedParams = {
        id: row.id,
        jobId: row.jobId,
        transportType: row.transportType,
        nos: row.innos,
      };
      this.visibleTrackList = true;
      this.getTrackList();
    },
    hideTrackList() {
      this.visibleTrackList = false;
      this.editTrackNeedParams = {};
    },
    selectionChangeValueTrack(value) {
      this.tableDataSelectValueTrack = value;
    },
    /**
     * 获取 轨迹列表
     */
    getTrackList(id = this.editTrackNeedParams.jobId) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.axios
          .post("/carrier/order/getJobsTracksInfo/" + id)
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.tableDataTrack = [];
              this.$message.info(res.data.message || "获取列表：服务器繁忙");
              return false;
            }
            this.tableDataTrack = res.data.datas;
            resolve(res);
          })
          .catch((res) => {
            if (res.message) console.warn(res.message);
            this.loading = false;
            this.tableDataTrack = [];
          });
      });
    },
    /**
     * 获取 轨迹状态
     */
    getTrackStatus(transportType = this.editTrackNeedParams.transportType) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.axios
          .post("/carrier/order/getTrackTemp/" + transportType)
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.trackStatusList = [];
              this.$message.info(res.data.message || "获取列表：服务器繁忙");
              return false;
            }
            this.trackStatusList = res.data.datas;
            resolve(res);
          })
          .catch((res) => {
            this.loading = false;
            this.trackStatusList = [];
          });
      });
    },
    changeTrackStatusId(value) {
      if (value) {
        let target = this.trackStatusList.find((res) => res.id === value);
        if (target) {
          this.editAddTrack.statusc = target.statusc || "";
          this.editAddTrack.statuse = target.statuse || "";
          this.editAddTrack.code = target.code || "";
        } else {
          this.editAddTrack.statusc = "";
          this.editAddTrack.statuse = "";
          this.editAddTrack.code = "";
        }
      } else {
        this.editAddTrack.tempId = "";
        this.editAddTrack.statusc = "";
        this.editAddTrack.statuse = "";
        this.editAddTrack.code = "";
      }
    },
    /**
     * 新增轨迹
     */
    showAddTrack(row) {
      this.editAddTrack.jobId = this.editTrackNeedParams.jobId;
      this.editAddTrack.nos = this.editTrackNeedParams.nos || "";
      this.visibleAddTrack = true;
      if (!this.trackStatusList.length) this.getTrackStatus();
    },
    hideAddTrack() {
      this.visibleAddTrack = false;
      Object.keys(this.editAddTrack).forEach((key) => {
        this.editAddTrack[key] = "";
      });
    },
    clickSaveAddTrack(formName = "addTrack") {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        // this.$message.success('调用添加轨迹接口');
        this.saveNewTrack();
        sendCustomerOperationRecord("轨迹管理提交");
      });
    },
    saveNewTrack() {
      let data = this.editAddTrack;
      if (!data.jobId) return this.$message.error("jobId为空");
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.axios
          .post("/carrier/order/insertJobsTrackById", data)
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.info(res.data.message || "新增：服务器繁忙");
              return false;
            }
            this.$message.success("新增成功");
            this.hideAddTrack();
            this.getTrackList();
            this.getList();
            resolve(res);
          })
          .catch((res) => {
            this.loading = false;
          });
      });
    },
    /**
     * 删除轨迹
     */
    clickDeleteTrack(row) {
      if (!row.id) return this.$message.error("删除项id为空");
      this.$confirm(`确认要删除该条轨迹嘛？`, "删除轨迹", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: "el-button--danger",
        type: "error",
      }).then(() => {
        this.deleteTrack(row);
      });
    },
    deleteTrack(row) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.axios
          .post("/carrier/order/deleteJobsTrackById/" + row.id)
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.info(res.data.message || "删除：服务器繁忙");
              return false;
            }
            this.$message.success("删除成功");
            this.getTrackList();
            resolve(res);
          })
          .catch((res) => {
            this.loading = false;
          });
      });
    },
    /**
     * 点击 编辑客户单号
     * @param row
     */
    clickEditClientNos(row) {
      this.showEditClientNos(row.beforeOrderId, row.outNos);
    },
    showEditClientNos(id = "", nos = "") {
      this.editClientNosData = {
        beforeOrderId: id,
        nos: nos,
      };
      this.visibleEditClientNos = true;
    },
    hideEditClientNos() {
      this.visibleEditClientNos = false;
      this.editClientNosData = {};
    },
    handleInWarehouse(data) {
      this.axios
        .post("/api/carrier/order/orderConfirmInWarehouse", { id: data.id })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.message);
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      const operationText = `订单号：${data.innos}，起运地：${data.polLandName}，目的地：${data.fbawarehouse}，专线产品名称：${data.lineProductName}`;
      sendCustomerOperationRecord("我的订单-入仓操作", operationText);
    },
    handleOutWarehouse(data) {
      this.axios
        .post("/api/carrier/order/orderConfirmOutWarehouse", { id: data.id })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.message);
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      const operationText = `订单号：${data.innos}，起运地：${data.polLandName}，目的地：${data.fbawarehouse}，专线产品名称：${data.lineProductName}`;
      sendCustomerOperationRecord("我的订单-出仓操作", operationText);
    },
  },
  computed: {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/orderManagement/FBAHeader.vue